import React from 'react';

export const CopyIcon = ({ 
  size = 20, 
  color = 'currentColor', 
  strokeWidth = 1.8,
  className = ''
}) => {
  const mainStroke = strokeWidth * 1.8;
  const outerStroke = strokeWidth * 1.8;

  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 40 40" 
      fill="none"
      className={className}
    >
      <path
        d="M25.332 24.5127C25.332 19.8712 25.332 17.5504 23.8901 16.1084C22.4481 14.6665 20.1274 14.6665 15.4859 14.6665H13.8449C9.20337 14.6665 6.88264 14.6665 5.44067 16.1084C3.9987 17.5504 3.9987 19.8712 3.9987 24.5127V26.1537C3.9987 30.7952 3.9987 33.1159 5.44067 34.5579C6.88264 35.9998 9.20337 35.9998 13.8449 35.9998H15.4859C20.1274 35.9998 22.4481 35.9998 23.8901 34.5579C25.332 33.1159 25.332 30.7952 25.332 26.1537V24.5127Z"
        stroke={color}
        strokeWidth={mainStroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.697 14.4081C13.7005 10.0113 13.767 7.73386 15.0469 6.17446C15.294 5.8733 15.5701 5.59718 15.8712 5.35003C17.5163 4 19.9603 4 24.8484 4C29.7365 4 32.1805 4 33.8255 5.35003C34.1267 5.59716 34.4028 5.8733 34.65 6.17446C36 7.81946 36 10.2635 36 15.1516C36 20.0397 36 22.4837 34.65 24.1288C34.4028 24.4299 34.1267 24.706 33.8255 24.9531C32.2661 26.233 29.9887 26.2995 25.5919 26.303"
        stroke={color}
        strokeWidth={outerStroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
